import { axios } from '/plugins/axios.client';
import { toast } from '/plugins/toaster.client.js';
import { getApplicationRedirectionUrl, getRedirectionURL } from '/src/common/apis/url/url-service';
import { i18n } from '/plugins/i18n.client';
import { TASK_COCKPIT, canAccessTaskCockpit } from '/src/common/login-landing-page';

/**
 * @method login
 * @description Login user
 * @param {object} user
 * @return {boolean} logged in successfully or not
 */
export const login = async (user) => {
  try {
    return await axios.$post('/auth/login', user);
  } catch (error) {
    const message = error && error.response && error.response.data && error.response.data.message;
    toast.error(message ? message : `Login failed. Please try again.`);
    return false;
  }
};

/**
 * @method generateToken
 * @description generates a new token during login
 * @return {boolean} generated token in successfully or not
 */
export const generateToken = async () => {
  try {
    await axios.$get('/generateToken');
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * @method logout
 * @description Logout User
 * @return {boolean} logged out successfully or not
 */
export const logout = async () => {
  try {
    await axios.$post('/auth/logout');
    return true;
  } catch (error) {
    return false;
  }
};

export const verifyOTP = async (otp) => {
  try {
    await axios.$post('/api/verify-otp', { otp });
    return true;
  } catch (error) {
    if (error?.response?.data?.url) {
      window.location = error?.response?.data?.url;
      return false;
    }
    const errorMessage = i18n.global.t('common.verify_otp.error_service', { service: 'verifying the OTP' });
    toast.error(error?.response?.data?.message || errorMessage);
    return false;
  }
};

export const resendOTP = async () => {
  try {
    await axios.$get('/api/resend-otp');
    toast.success(i18n.global.t('common.verify_otp.resend'));
  } catch (error) {
    const errorMessage = i18n.global.t('common.verify_otp.error_service', { service: 'resetting the OTP' });
    toast.error(error?.response?.data?.message || errorMessage);
  }
};

export const getHomeScreenUrl = async (userDetails = {}, options = {}) => {
  const respectToggle = typeof options === 'boolean' ? options : !!options.respectToggle;

  if (respectToggle && !userDetails.UseHomeScreenAsHomeDestination) {
    return '/launchpad';
  }

  if (userDetails.HomeScreen === TASK_COCKPIT) {
    if (!canAccessTaskCockpit(userDetails)) {
      return '/launchpad';
    }
    const myTaskUrl = userDetails.platFormSettings?.MENU_TASKS_URL;
    if (myTaskUrl) {
      const { url } = await getRedirectionURL({ linkType: 'Custom', state: myTaskUrl });
      return url;
    }
    return '/tasks/my';
  }

  const app = userDetails.HomeScreenDetails;
  if (app) {
    let urlJSON = (app.TargetStateJSON || '{}').sParseJSON();
    urlJSON = Object.keys(urlJSON).length !== 0 ? urlJSON : { linkType: 'Custom', state: app.TargetState };
    const { url } = await getApplicationRedirectionUrl({ ...app, urlJSON });
    return url || '/launchpad';
  }

  return '/launchpad';
};
